import envs from "../envs";

export const mapaContratosDeAdesao =
  "/AreaAberta/Consorcio/Contratos/Contratos.json";

export const calendarioAssembleias =
  "/AreaAberta/Consorcio/Assembleias/calendario-assembleias.json";

export const mapaCartilhaParaContemplados =
  "/AreaAberta/Consorcio/Cartilhas/Cartilha-para-contemplados.json";

export const listaParceirosCredenciados = `/AreaAberta/Consorcio/ParceirosCredenciados/parceiros-credenciados.json`;

export const mapaCartilhaDeOrientacoes =
  "/AreaAberta/Consorcio/Cartilhas/Cartilha-de-orientacoes.json";

export const mapaFormularioParaTransferencia =
  "/AreaAberta/Consorcio/Cartilhas/Formulario-para-transferencia.json";

export const riscosExcluidos = `${envs.hostStaticCdn}/AreaAberta/Consorcio/RiscosExcluidos/Apolice_Prestamista_Residencial_DFI.pdf`;
export const cartilhaFgts = `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CARTILHA-FGTS.pdf`;
export const mapaAssistenciaGeralExtraordinaria =
  "/AreaAberta/Consorcio/AssembleiaGeralExtraordinaria/AssembleiaGeralExtraordinaria.json";

export const home = `/paravoce/consorcios`;
export const seguros = `${home}/seguros`;
export const desisti = `${home}/desisti-do-consorcio`;
export const contemplacao = `${home}/contemplacao`;
export const entendaSobreConsorcio = `${home}/entenda-sobre-consorcio#o-que-fazer-com-seu-credito`;
export const assembleias = `${home}/assembleias`;

export const areaLogada = `${envs.hostAreaLogada}/login/consorcio`;
